import { createAction } from '@reduxjs/toolkit';
import { AsyncData } from '@shared/interfaces/asyncData';
import { Coordinates } from '@shared/interfaces/Coordinates';
import { User } from '@shared/interfaces/user';

export const setCurrentUser = createAction<AsyncData<User>>('user/setCurrentUser');
export const getCurrentUser = createAction<void>('user/getCurrentUser');
export const acceptTermsOfUse = createAction<string>('user/acceptTermsOfUse');
export const checkCurrentLocation = createAction<Coordinates | undefined>('user/checkCurrentLocation');
